<div class="mt-32">
  <table class="tbl tbl--full tbl--hovered">
    <colgroup>
      <col width="3%" />
      <col width="13%" />
      <col width="9%" />
      <col width="8%" />
      <col width="8%" />
      <col width="11%" />
      <col width="8%" />
      <col width="10%" />
      <col width="6%" />
      <col width="7%" />
      <col width="8%" />
      <col width="9%" />
    </colgroup>
    <thead>
      <tr>
        <th>ID</th>
        <th>ФИО</th>
        <th>Телефон</th>
        <th>Регион</th>
        <th>Филиал</th>
        <th>Участок</th>
        <th>Наличие автомобиля</th>
        <th>Тип</th>
        <th>Статус</th>
        <th>Стаж, г.</th>
        <th>Основная роль</th>
        <th>Табельный номер подрядчика</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let user of userListFiltered">
        <tr
          [ngClass]="{
            'bg-gray-bright-light': user.u_id == (userExpanded && userExpanded.u_id),
            'color-gray-dark': user.employer && user.employer.status && user.employer.status.es_id === 2
          }"
        >
          <td>{{ user.u_id }}</td>
          <td>
            <div class="grid grid--gap-4">
              <div
                class="grid__box grid__box--size-min pt-4"
                (click)="
                  onChangeUserExpanded.emit({
                    user: user,
                    state: 'open'
                  })
                "
                *ngIf="user.u_id !== (userExpanded && userExpanded.u_id)"
              >
                <app-icon [size]="'10'" [glyph]="'arrow-right'" [class]="'cursor-pointer'"></app-icon>
              </div>
              <div
                class="grid__box grid__box--size-min pt-4"
                (click)="
                  onChangeUserExpanded.emit({
                    user: user,
                    state: 'close'
                  })
                "
                *ngIf="user.u_id == (userExpanded && userExpanded.u_id)"
              >
                <app-icon [size]="'10'" [glyph]="'arrow-down'" [class]="'cursor-pointer'"></app-icon>
              </div>
              <div
                class="grid__box ww-break-word"
                (click)="
                  onChangeUserExpanded.emit({
                    user: user,
                    state: 'open'
                  })
                "
                *ngIf="user.u_id !== (userExpanded && userExpanded.u_id)"
              >
                {{ user.employee && user.employee.last_name}}
                {{ user.employee && user.employee.first_name}}
                {{ user.employee && user.employee.patronymic_name}}
              </div>
              <div
                class="grid__box ww-break-word"
                (click)="
                  onChangeUserExpanded.emit({
                    user: user,
                    state: 'close'
                  })
                "
                *ngIf="user.u_id == (userExpanded && userExpanded.u_id)"
              >
                {{ user.employee && user.employee.last_name}}
                {{ user.employee && user.employee.first_name}}
                {{ user.employee && user.employee.patronymic_name }}
              </div>
            </div>
          </td>
          <td>
            {{ user.employee && user.employee.phone}}
          </td>
          <td>
            <span>{{ user.region_name }}</span>
          </td>
          <td>
            <span>{{ user.branch_name }}</span>
          </td>
          <td>
            <span>
              <span *ngFor="let plot of user.user_sectors; let last = last">
                {{ plot.sector_number }}
                <span *ngIf="!last"> / </span>
              </span>
            </span>
          </td>
          <td>
            <app-icon
              [glyph]="user.has_transport ? 'car' : 'run'"
              [size]="'16'"
              [color]="'gray'"
              [attr.title]="user.has_transport ? 'Есть автомобиль' : 'Пешком'"
            ></app-icon>
          </td>
          <td>
            {{ user.employer.employee_type && user.employer.employee_type.et_name }}
          </td>
          <td>
            {{ user.employer.status && user.employer.status.es_name }}
          </td>
          <td>{{ user.employer.hire_date | timeRange }}</td>
          <td>{{ user.default_group_name }}</td>
          <td>
            <div style="width: 100px">
              <app-partner-code-popover [employee]="user.employee"></app-partner-code-popover>
            </div>
          </td>
        </tr>
        <tr *ngIf="user.u_id == (userExpanded && userExpanded.u_id)">
          <td colspan="12" *ngIf="userExpanded.userExpandedDataLoading" class="pos-r bg-gray-pale">
            <div class="pt-24 pb-24">
              <app-loader></app-loader>
            </div>
          </td>
          <td colspan="12" class="td--reset-padding" *ngIf="!userExpanded.userExpandedDataLoading">
            <div class="bg-gray-pale pt-16 pb-24 pl-24">
              <div class="collaborators-description mb-24">
                <div class="collaborators-description__item">
                  <div class="tt-uppercase color-gray-dark">Личные данные</div>
                  <div class="grid mt-8">
                    <div class="grid__box grid__box--size-5">
                      <b>Дата рождения</b>
                    </div>
                    <div class="grid__box grid__box--size-6">
                      {{ userExpanded.employee.birthday | dateFormat: 'DD.MM.YYYY г.' }}
                    </div>
                  </div>
                  <div class="grid mt-8">
                    <div class="grid__box grid__box--size-5">
                      <b>Фото</b>
                    </div>
                    <div class="grid__box grid__box--size-6">
                      <span *ngIf="!userExpanded.employee.photo">Нет</span>
                      <a *ngIf="userExpanded.employee.photo" class="link link--dotted-bluer-dark" [ngbPopover]="uploadFilePreview" [placement]="'bottom'"> Посмотреть </a>
                    </div>
                  </div>
                  <div class="tt-uppercase color-gray-dark mt-16">контакты</div>
                  <div class="grid mt-8">
                    <div class="grid__box grid__box--size-5">
                      <b>Доп. номер</b>
                    </div>
                    <div class="grid__box grid__box--size-6">
                      <div *ngFor="let phone of userExpanded.phones">
                        <div *ngIf="phone.priority == '0'">
                          {{ phone.phone | phoneFormat }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="grid mt-8">
                    <div class="grid__box grid__box--size-5">
                      <b>E-mail</b>
                    </div>
                    <div class="grid__box grid__box--size-6 ww-break-word">
                      {{ userExpanded.employee.email }}
                    </div>
                  </div>
                </div>
                <div class="collaborators-description__item border-left border--gray-bright">
                  <div class="pl-16">
                    <div class="tt-uppercase color-gray-dark mt-16">Транспортное средство</div>
                    <div class="grid mt-8">
                      <div class="grid__box grid__box--size-6">
                        <b>Наличие</b>
                      </div>
                      <div class="grid__box grid__box--size-6">
                        <span *ngIf="userExpanded.transport">Да</span>
                        <span *ngIf="!userExpanded.transport">Нет</span>
                      </div>
                    </div>
                    <div class="grid mt-8">
                      <div class="grid__box grid__box--size-6">
                        <b>Гос. номер</b>
                      </div>
                      <div class="grid__box grid__box--size-6">
                        <span *ngIf="userExpanded.transport">{{ userExpanded.transport.tf_number }}</span>
                        <span *ngIf="!userExpanded.transport" class="mdash"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="collaborators-description__item border-left border--gray-bright">
                  <div class="pl-16">
                    <div class="tt-uppercase color-gray-dark">место работы</div>
                    <div class="grid mt-8">
                      <div class="grid__box grid__box--size-6">
                        <b>Компания</b>
                      </div>
                      <div class="grid__box grid__box--size-6">
                        <a
                          class="link"
                          id="{{ 'appUserView' + userExpanded.employer.partnership_id }}"
                          [routerLink]="[
                            '/' + COMPANIES_PATHS.companies,
                            {
                              companyId: userExpanded.employer.partnership_id
                            }
                          ]"
                        >
                          “{{ userExpanded.employer.partnership_name }}”
                        </a>
                      </div>
                    </div>
                    <div class="grid mt-8">
                      <div class="grid__box grid__box--size-6">
                        <b>Служебная функция</b>
                      </div>
                      <div class="grid__box grid__box--size-6">
                        {{ userExpanded.employer.service_function_name }}
                      </div>
                    </div>
                    <div *ngFor="let role of userExpanded.user_groups">
                      <div class="grid mt-8" *ngIf="role.group.id === 4">
                        <div class="grid__box grid__box--size-6">
                          <b>Часовой пояс</b>
                        </div>
                        <div class="grid__box grid__box--size-6">
                          UTC+{{ userExpanded.user_timeshift }}
                          {{ userExpanded.user_time | dateFormat: 'HH:mm' }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="collaborators-description__item border-left border--gray-bright">
                  <div class="pl-16">
                    <div class="tt-uppercase color-gray-dark">роли</div>
                    <div class="grid mt-8">
                      <div class="grid__box grid__box--size-5">
                        <b
                          >Доступные сотруднику<br />
                          роли</b
                        >
                      </div>
                      <div class="grid__box grid__box--size-6">
                        <div *ngFor="let role of userExpanded.user_groups">
                          <app-user-role-expanded-popover [role]="role" [userId]="user.u_id"></app-user-role-expanded-popover>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="collaborators-description__item border-left border--gray-bright">
                  <div class="pl-16">
                    <div class="tt-uppercase color-gray-dark">дополнительные данные</div>
                    <div class="grid mt-8">
                      <div class="grid__box grid__box--size-7">
                        <b>Табельный номер ВК</b>
                      </div>
                      <div class="grid__box grid__box--size-4">
                        {{ userExpanded.employee.emp_number }}
                      </div>
                    </div>
                    <div class="grid mt-8">
                      <div class="grid__box grid__box--size-7">
                        <b>Дата приема на работу</b>
                      </div>
                      <div class="grid__box grid__box--size-4">
                        {{ userExpanded.employer.hire_date | dateFormat: 'DD.MM.YYYY г.' }}
                      </div>
                    </div>
                    <div class="grid mt-8">
                      <div class="grid__box grid__box--size-7">
                        <b>Дата увольнения</b>
                      </div>
                      <div class="grid__box grid__box--size-4">
                        <div *ngIf="!userExpanded.employer.dismissal_date" class="mdash"></div>
                        <div *ngIf="userExpanded.employer.dismissal_date">
                          {{ userExpanded.employer.dismissal_date | dateFormat: 'DD.MM.YYYY г.' }}
                        </div>
                      </div>
                    </div>
                    <div class="grid mt-8">
                      <div class="grid__box grid__box--size-7">
                        <b>Номер удостоверения</b>
                      </div>
                      <div class="grid__box grid__box--size-4">
                        {{ userExpanded.employer.token_number }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <app-role-access [action]="'disable'" [permission]="'employee.edit'" [placement]="'bottom-left'">
                <a data-role-element class="link" [routerLink]="['/users', userExpanded.u_id]">
                  <button class="button" id="{{ 'appEditUser' + userExpanded.u_id }}" type="button">Редактировать профиль</button>
                </a>
              </app-role-access>
            </div>
          </td>
        </tr>
      </ng-container>
      <tr *ngIf="userListFiltered && !userListFiltered.length && emptyMessage" class="tr--reset-highlight">
        <td colspan="12">
          <div class="ta-center color-gray-dark pt-32 mt-8">
            {{ emptyMessage }}
          </div>
        </td>
      </tr>
      <tr *ngIf="!userDataIsLoaded" class="tr--reset-highlight">
        <td colspan="12">
          <div class="ta-center color-gray-dark pt-32 mt-8">Для поиска сотрудников заполните хотя бы одно поле фильтра.</div>
        </td>
      </tr>
    </tbody>
  </table>
  <app-pagination (onLoadPartial)="paginationBlock.onLoadPartial($event)"></app-pagination>
</div>

<ng-template #uploadFilePreview>
  <div class="padding-8">
    <img class="img_user_preview" src="{{ environment.apiPrefix + '/admin/users/' + userExpanded.employee.e_id + '/userpic/' }}" />
  </div>
</ng-template>
